export const myColor = {
  blue: {
    main: '#012F5B',
    background: '#F1F8FF',
    10: '#003D78',
    active: '#025382',
    highlight: '#0185F0',
    backgroundCard: '#E8F3FE',
    steelBlue: '#4273A2',
  },

  green: {
    border: '#49de80',
    dot: '#22c55e',
  },

  black: {
    main: '#273552',
    jetBlack: '#3B3B3B',
    10: '#495871',
    20: '#A2AEBD',
    silver: '#ADADAD',
  },

  white: {
    main: '#FFFFFF',
    10: '#E7EAEF',
    20: '#DBDFEF',
    30: '#F5F6F8',
    40: '#F5F9FF',
    50: '#EBEFF7',
    60: '#FAFCFF',
    70: '#D0E6FF',
    80: '#D4D4D4',
  },

  red: {
    main: '#EA5455',
  },

  other: {
    10: '#FFF7E5',
    20: '#FCF2DE',
    gray: '#F2F2F2',
    gray700: '#374151',
    burntOrange: '#BC5800',
    divider: '#D0D0D0',
    lightSlate: '#CFDBE6',
  },

  hightlight: {
    main: '#2C68DE',
    10: '#025282',
  },

  yellow: {
    papayaWhip: '#FFEAD0',
    deepPeach: '#FFCD8D',
  },
};
